import {  Component, Input, OnDestroy, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Location, BlockoutSection } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '@finder/features/calendars/services/calendars.service';
import { DateRange } from '@finder/features/calendars/calendars.interface';
import { SectionComponent } from '@finder/shared/components/section/section.component';
import { CommonModule } from '@angular/common';
import { AnchorComponent } from '@finder/shared/components/anchor/anchor.component';
import { InArrayPipe } from '@finder/shared/utils/pipes/in-array/in-array.pipe';

@Component({
    selector: 'finder-park-row',
    templateUrl: './park-row.component.html',
    styleUrls: ['./park-row.component.scss'],
    standalone: true,
    imports: [
        SectionComponent,
        CommonModule,
        AnchorComponent,
        InArrayPipe
    ]
})
export class ParkRowComponent implements OnInit, OnDestroy {

    @Input() location: Location;
    @Input() labels: any;

    loading = false;
    blockouts: BlockoutSection;
    sections: Array<any>;
    dateRange: DateRange;
    showLinks: boolean;
    closedForRefurbishmentLink: string;
    permanentSchedule: any;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarsService: CalendarsService,
    ) { }

    ngOnInit() {
        this.setSections();
        this.setBlockouts();
        this.dateRange = this.calendarsService.dateRange;
        this.showLinks = this.calendarsService.allowLinksOnPage();
        this.closedForRefurbishmentLink =
            `${this.calendarsService.getCalendarsDefaultPath()}${this.location.closedForRefurbishmentLink?.href}`;
        this.permanentSchedule = this?.location?.permanentSchedule;

        this.calendarsService.getLoadingState()
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.loading = state);

        this.calendarsService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(locations => {
                this.dateRange = this.calendarsService.dateRange;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setSections() {
        const events = this.location.events ?? {};
        this.sections = Object.keys(events).map((type) => {
            const eventGroup = events[type];
            const data = eventGroup.data ?? [];
            const permanentActivity = eventGroup?.permanentActivity ?? void 0;

            return {
                id: `${this.location.urlFriendlyId}--${type}`,
                type,
                data,
                permanentActivity,
                labels: {
                    sectionTitle: eventGroup.title
                }
            };
        });

    }

    setBlockouts() {
        const blockouts = this.location.blockouts;
        if (!blockouts) {
            return;
        }

        this.blockouts = {
            id: `${this.location.urlFriendlyId}--blockouts`,
            data: blockouts,
            labels: {
                sectionTitle: this.labels.blockouts
            }
        };
    }
}
